import { Directive, ViewContainerRef } from '@angular/core';
import { AppLayoutSecureService } from '../../secure.service';

@Directive({
  selector: '[app-layout-side-end]',
})
export class AppLayoutSecureSideEndDirective {
  constructor(
    public viewContainerRef: ViewContainerRef,
    private _appLayoutSecure: AppLayoutSecureService
  ) {
    this._appLayoutSecure.setSideEnd(this);
  }
}
